export const CHECKBOX_ICON_CLASS = 'MvCheckbox-icon';
export const CHECKBOX_BORDER_CLASS = 'MvCheckbox-border';
export const CHECKBOX_FILL_CLASS = 'MvCheckbox-fill';
export const CHECKBOX_GLYPH_CLASS = 'MvCheckbox-glyph';
export const CHECKBOX_CHECK_CLASS = 'MvCheckbox-check';
export const CHECKBOX_MINUS_CLASS = 'MvCheckbox-minus';

export const CHECKBOX_BOX_PX = { medium: 20, small: 16 } as const;

const GLYPH_SCALE = { medium: 0.8, small: 0.6 } as const;
const GLYPH_INSET_PX = 2;
const GLYPH_STROKE_WIDTH = 1;
const BORDER_WIDTH_PX = 1;
const BOX_RADIUS_PX = 4;

const GLYPH = {
  check: {
    className: CHECKBOX_CHECK_CLASS,
    path: 'M7.5 13.4758L4.025 10.0008L2.8417 11.1758L7.5 15.8342L17.5 5.8342L16.325 4.6592L7.5 13.4758Z',
  },
  minus: {
    className: CHECKBOX_MINUS_CLASS,
    path: 'M5 9.1667H15A0.8333 0.8333 0 0 1 15 10.8333H5A0.8333 0.8333 0 0 1 5 9.1667Z',
  },
} as const;

type CheckboxIconSize = keyof typeof CHECKBOX_BOX_PX;

interface CheckboxIconProps {
  glyph?: keyof typeof GLYPH;
  fontSize?: string;
}

const CheckboxIcon = ({ glyph, fontSize }: CheckboxIconProps) => {
  const size: CheckboxIconSize = fontSize === 'small' ? 'small' : 'medium';
  const box = CHECKBOX_BOX_PX[size];
  const inner = box - 2 * BORDER_WIDTH_PX;

  return (
    <svg
      className={CHECKBOX_ICON_CLASS}
      width={box}
      height={box}
      viewBox={`0 0 ${box} ${box}`}
      aria-hidden="true"
      focusable="false"
    >
      <rect
        className={CHECKBOX_BORDER_CLASS}
        width={box}
        height={box}
        rx={BOX_RADIUS_PX}
        fill="currentColor"
      />
      <rect
        className={CHECKBOX_FILL_CLASS}
        x={BORDER_WIDTH_PX}
        y={BORDER_WIDTH_PX}
        width={inner}
        height={inner}
        rx={BOX_RADIUS_PX - BORDER_WIDTH_PX}
        fill="currentColor"
      />
      {glyph && (
        <path
          className={`${CHECKBOX_GLYPH_CLASS} ${GLYPH[glyph].className}`}
          transform={`translate(${GLYPH_INSET_PX} ${GLYPH_INSET_PX}) scale(${GLYPH_SCALE[size]})`}
          d={GLYPH[glyph].path}
          fill="currentColor"
          stroke="currentColor"
          strokeWidth={GLYPH_STROKE_WIDTH}
          strokeLinejoin="round"
        />
      )}
    </svg>
  );
};

export const CHECKBOX_ICON = <CheckboxIcon />;
export const CHECKBOX_CHECKED_ICON = <CheckboxIcon glyph="check" />;
export const CHECKBOX_INDETERMINATE_ICON = <CheckboxIcon glyph="minus" />;
